module.exports = __webpack_public_path__ + "static/img/thumb-02.3252bf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/thumb/thumb-02.png
// module id = E3a3
// module chunks = 150